// extracted by extract-css-chunks-webpack-plugin
module.exports = {"spacer":"css-3KPmpuK_kg","spacer__inlineCategoryContent":"css-LSbHbOTNmg","spacer__mobile":"css-31o4AFnvrM"};